enum ActionTypes {
  LOAD_SAMPLE_POINTS_STATISTICS_REQUEST = 'LOAD_SAMPLE_POINTS_STATISTICS_REQUEST',
  LOAD_SAMPLE_POINTS_STATISTICS_SUCCESS = 'LOAD_SAMPLE_POINTS_STATISTICS_SUCCESS',
  LOAD_SAMPLE_POINTS_STATISTICS_FAILURE = 'LOAD_SAMPLE_POINTS_STATISTICS_FAILURE',
  SET_SAMPLE_POINTS_STATISTICS = 'SET_SAMPLE_POINTS_STATISTICS',
  UPDATE_SAMPLE_POINTS_STATISTICS = 'UPDATE_SAMPLE_POINTS_STATISTICS'
}

export default ActionTypes;
